<div class="loading-overlay" *ngIf="loading">
  <!-- show something fancy here, here with Angular 2 Material's loading bar or circle -->
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
<div class="preloadStyle" id="preloaderAdmin" style="display: none">
  <div class="spinner_admin">
    <div class="rect1"></div>
    <div class="rect2"></div>
    <div class="rect3"></div>
    <div class="rect4"></div>
    <div class="rect5"></div>
    <div
      id="preloaderAdminText"
      style="
        width: 354px;
        height: 100px;
        background: none;
        color: white;
        position: absolute;
        animation: unset;
        font-size: 20px;
        margin-top: 35px;
        margin-left: -196px;
      "></div>
  </div>
</div>
<router-outlet></router-outlet>
